import FnrEnvironment from "Utilities/FnrEnvironment";
import FnrFetch from "Utilities/FnrFetch";
import FnrFetch2 from "Utilities/FnrFetch/FnrFetch2.js";
import FnrFetch3, { callMockResponse } from "Utilities/FnrFetch/FnrFetch3";
import FnrFetch4 from "Utilities/FnrFetch/FnrFetch4";



import devAPI from "./API.dev.js";
import { mockData } from "./mockData";


const getAnonymousUser = () =>
  JSON.parse(localStorage.getItem("anonymousUser"));

let API = {
  getSignupLists: () => new FnrFetch2("/signuplist/list"),

  getSignupListInfo: (signupID) =>
    new FnrFetch4(
      "/signuplist/" + signupID + "/publicView",
      null,
      mockData.shouldMock ? mockData.signupListPublicView : null
    ),

  signupForItem: (
    signupItemID,
    numberOfSlots,
    noteID = null,
    user,
    additionalNames = null,
    signedUpViaID = null
  ) => {
    const postData = { signupItemID: signupItemID };
    if (numberOfSlots) postData.numberOfSlots = numberOfSlots;
    if (noteID) postData.noteID = noteID;
    if (user) postData.user = user;
    if (additionalNames) postData.additionalNames = additionalNames;
    const anonymousUser = getAnonymousUser();
    if (anonymousUser && !user)
      postData.user = { emailOrPhone: anonymousUser.emailOrPhone };
    if (signedUpViaID) postData.signedUpViaID = signedUpViaID;

    return new FnrFetch2("/signupList/signupForItem", postData, true);
  },

  signupForItem2: ({
    signupItemID, // required!
    user,
    numberOfSlots,
    noteID,
    additionalNames,
    signedUpViaID,
    extendedFieldInputResponses,
    sharedExtendedFieldInputResponses,
  }) => {
    const postData = {
      signupItemID,
      extendedFieldInputResponses,
      sharedExtendedFieldInputResponses,
    };
    if (user) postData.user = user; // if user does not get included, the endpoint will look up the currently logged in user.
    if (numberOfSlots) postData.numberOfSlots = numberOfSlots; // if this is omitted, endpoint will default to 1
    if (noteID) postData.noteID = noteID;
    if (additionalNames) postData.additionalNames = additionalNames;
    if (signedUpViaID) postData.signedUpViaID = signedUpViaID;

    return new FnrFetch2("/signupList/signupForItem", postData, true);
  },

  signupHouseholdUsersForItem: (submitData) => {
    return new FnrFetch2(
      "/signuplist/signupHouseholdUsersForItem",
      submitData,
      true
    );
  },

  removeRespondent: (signupListID, postData) => {
    return new FnrFetch2(
      `/signuplist/${signupListID}/cancelOtherUserSignup`,
      postData,
      true
    );
  },

  // this is a re-write of `removeRespondent`
  cancelOtherUserSignup: ({
    signupListID,
    signupItemID,
    userID,
    signedUpViaID,
  }) => {
    const submitData = { signupItemID, userID };
    if (signedUpViaID) submitData.signedUpViaID = signedUpViaID;

    return new FnrFetch2(
      `/signuplist/${signupListID}/cancelOtherUserSignup`,
      submitData,
      true
    );
  },

  updateRespondentNumberOfSlots: (signupListID, postData) =>
    FnrFetch.post(
      `/signuplist/${signupListID}/updateUserSignupSlots`,
      postData,
      true
    ),

  // this is a re-write of `updateRespondentNumberOfSlots`
  updateUserSignupSlots: ({
    signupListID,
    signupItemID,
    userID,
    numberOfSlots,
    signedUpViaID,
    shouldRefund,
    refundAmount,
  }) => {
    return new FnrFetch2(
      `/signuplist/${signupListID}/updateUserSignupSlots`,
      {
        signupItemID,
        userID,
        numberOfSlots,
        signedUpViaID,
        shouldRefund,
        refundAmount,
      },
      true
    );
  },

  cancelSignupForItem: (ID, signedUpViaID = null) => {
    let postData = { signupItemID: ID, signedUpViaID: signedUpViaID };

    const anonymousUser = getAnonymousUser();
    if (anonymousUser) postData.emailOrPhone = anonymousUser.emailOrPhone;

    return new FnrFetch2("/signuplist/cancelUserSignup", postData, true);
  },

  cancelSignupForItem2: ({
    signupItemID,
    signedUpViaID = null,
    emailOrPhone, // only necessary if its an anonymousUser who is cancelling the signup
  }) => {
    let postData = { signupItemID, signedUpViaID };
    if (emailOrPhone) postData.emailOrPhone = emailOrPhone;

    return new FnrFetch2("/signuplist/cancelUserSignup", postData, true);
  },

  cancelAllHouseholdUserSignups: ({
    signupListID,
    signupItemID,
    householdID,
    signedUpViaID,
  }) => {
    const submitData = { signupItemID, householdID };

    if (signedUpViaID) {
      submitData.signedUpViaID = signedUpViaID;
    }

    return new FnrFetch2(
      `/signuplist/${signupListID}/cancelAllHouseholdUserSignups`,
      submitData,
      true
    );
  },

  modifyHouseholdUserSignups: ({
    signupListID,
    signupItemID,
    householdID,
    numberOfSlots,
    signedUpViaID,
    usersToSignup,
    additionalNames,
    extendedFieldInputResponses,
    sharedExtendedFieldInputResponses,
  }) => {
    const submitData = {
      signupListID,
      signupItemID,
      householdID,
      numberOfSlots,
      usersToSignup,
      additionalNames,
      extendedFieldInputResponses,
      sharedExtendedFieldInputResponses,
    };

    if (signedUpViaID) {
      submitData.signedUpViaID = signedUpViaID;
    }

    return new FnrFetch2(
      `/signuplist/${signupListID}/modifyHouseholdUserSignups`,
      submitData,
      true
    );
  },

  getHouseholdUsers: ({ signupListID, householdID }) => {
    return new FnrFetch2(
      `/signuplist/${signupListID}/getHouseholdUsers`,
      { householdID },
      true
    );
  },

  addAdditionalName: ({
    name,
    primaryUserID,
    signupItemID,
    signupListID,
    signedUpViaID,
  }) => {
    const submitData = { name, primaryUserID, signupItemID };

    if (signedUpViaID) {
      submitData.signedUpViaID = signedUpViaID;
    }

    return new FnrFetch2(
      `/signuplist/${signupListID}/addAdditionalName`,
      submitData,
      true
    );
  },

  removeAdditionalName: ({ additionalNameID, signupListID, signedUpViaID }) => {
    const submitData = { additionalNameID };

    if (signedUpViaID) submitData.signedUpViaID = signedUpViaID;

    return new FnrFetch2(
      `/signuplist/${signupListID}/removeAdditionalName`,
      submitData,
      true
    );
  },

  signupOtherUserForItem: ({
    signupListID,
    signupItemID,
    userID,
    numberOfSlots = 1,
    isReactivation = false,
    signedUpViaID,
  }) => {
    const submitData = {
      signupItemID,
      userID,
      numberOfSlots,
      isReactivation,
    };
    if (signedUpViaID) submitData.signedUpViaID = signedUpViaID;

    return new FnrFetch2(
      `/signuplist/${signupListID}/signupOtherUserForItem`,
      submitData,
      true
    );
  },

  deleteSignupList: (ID) => new FnrFetch2("/signuplist/" + ID + "/delete"),

  createSignupList: (signupList) => {
    return new FnrFetch3("/signuplist/create", signupList);
  },

  editSignupList: (ID, signupList) => {
    const url = ID
      ? "/signuplist/" + ID + "/edit"
      : "/signuplist/editSignupList";

    return FnrFetch.post(url, signupList, false);
  },

  editTitle: (ID, title) => {
    const url = "/signuplist/" + ID + "/edittitle";

    const body = {
      signupListID: ID,
      title: title,
    };

    return FnrFetch.post(url, body, false);
  },

  editDescription: (ID, description) => {
    const url = "/signuplist/" + ID + "/editdescription";

    const body = {
      signupListID: ID,
      description: description,
    };

    return FnrFetch.post(url, body, false);
  },

  editSignupListOption: (ID, postData) =>
    mockData.shouldMock
      ? callMockResponse(() => mockData.editSignupListOption(postData)).post()
      : FnrFetch.post(
          "/signuplist/" + ID + "/editsignuplistoption",
          postData,
          true
        ),

  editFundItOptions: (signupListID, postData) =>
    mockData.shouldMock
      ? callMockResponse(() => mockData.editFundItOptions(postData))
      : new FnrFetch3(
          `/signuplist/${signupListID}/editfunditoptions`,
          postData
        ),

  editItemFundItOptions: (signupListID, postData) =>
    mockData.shouldMock
      ? callMockResponse(() => mockData.editItemFundItOptions(postData))
      : new FnrFetch3(
          `/signuplist/${signupListID}/edititemfunditoptions`,
          postData
        ),

  duplicate: (ID) => {
    const url = "/signuplist/" + ID + "/duplicate";

    const body = {
      duplicateID: ID,
    };

    return FnrFetch.post(url, body, false);
  },

  createItem: (ID, createItemBody) =>
    new FnrFetch4(`/signuplist/${ID}/createitem`, createItemBody),

  editItem: (ID, editItemBody) =>
    new FnrFetch4(`/signuplist/${ID}/edititem`, editItemBody),

  removeSignupListItem: (signupListID, itemID) =>
    new FnrFetch4(`/signuplist/${signupListID}/deleteItem`, {
      signupListItemID: itemID,
    }),

  getDefaultSignupListTypeVerb: () =>
    new FnrFetch2("/signuplist/getDefaultSignupListTypeVerb"),

  saveCustomEmailConfirmation: (ID, postData) =>
    new FnrFetch2(`/signuplist/${ID}/saveCustomConfirmationEmail`, postData),
  getAllSignupListTypes: (ID) =>
    new FnrFetch2(`/signuplist/${ID}/getAllSignupListTypes`),

  changeSignupType: (ID, postData) =>
    new FnrFetch2(`/signuplist/${ID}/changeSignupType`, postData),

  changeSignupStatus: (ID, status) =>
    new FnrFetch2(`/signuplist/${ID}/changeSignupStatus`, { status: status }),

  searchForMember: ({ searchTerm, signupItemID }) =>
    new FnrFetch2("/signuplist/search", { searchTerm, signupItemID }),

  addSignupListToGroup: ({ signupListID, groupID }) =>
    new FnrFetch2(`/signuplist/${signupListID}/addSignupListToGroup`, {
      groupID,
    }),

  addSignupListItemToGroup: ({ signupListID, signupListItemID, groupID }) =>
    new FnrFetch2(`/signuplist/${signupListID}/addSignupListItemToGroup`, {
      signupListItemID,
      groupID,
    }),

  createLinkedGroups: ({ signupID }) =>
    new FnrFetch2(`/signuplist/${signupID}/createLinkedGroups`),

  linkSignupItemToGroup: ({ signupID, signupItemID, groupID }) =>
    new FnrFetch2(`/signuplist/${signupID}/linkSignupListItemToGroup`, {
      signupListItemID: signupItemID,
      groupID,
    }),

  unlinkSignupItemFromGroup: ({ signupID, signupItemID }) =>
    new FnrFetch2(`/signuplist/${signupID}/unlinkSignupListItemFromGroup`, {
      signupListItemID: signupItemID,
    }),

  getAvailableGroupsForSignupLinking: ({ signupID }) =>
    new FnrFetch2(`/signuplist/${signupID}/getAvailableGroupsForSignupLinking`),

  getAvailableGroupsForBulkAction: (ID) =>
    new FnrFetch2(`/signuplist/${ID}/getAvailableGroupsForBulkAction`),

  sendManualReminder: (signupListID) =>
    new FnrFetch2(`/signuplist/${signupListID}/sendManualReminder`),

  sendPaymentReminder: (signupListID) =>
    new FnrFetch2(`/signuplist/${signupListID}/sendPaymentReminder`),

  reorderItems: (signupListID, postData = {}) =>
    new FnrFetch3(`/signuplist/${signupListID}/reorderitems`, postData),

  // 	exportSignupList: ID => FnrFetch.post('/signuplist/'+ID+'/export')

  markAsPaid: (signupListID, postData) =>
    new FnrFetch3(`/signuplist/${signupListID}/markAsPaid`, postData),

  calculatePaymentAmount: ({ signupID, postData }) =>
    new FnrFetch3(`/signupList/${signupID}/calculatePaymentAmount`, postData),

  /**
   * copies extended fields on a signup item (signupListItemID) to the other item on the signup.
   * @param {object} param0
   * @param {number} param0.signupListItemID
   */
  copyExtendedFields: ({ signupListItemID }) =>
    new FnrFetch3("/signupList/copyExtendedFields", { signupListItemID }),
};

if (FnrEnvironment.shouldUseDevAPI()) API = { ...API, ...devAPI };

export default API;